import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import {
  CreateTestRow,
  TestRow,
  TestRowWithResult,
  UpdateTestRow,
} from "./test.type";

export const getTests = async (
  userId?: string
): Promise<TestRowWithResult[]> => {
  const slug = ApiEndpoints.test + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<TestRowWithResult[]>(slug, options);
};

export const updateTest = async (
  test: UpdateTestRow,
  patientUserId?: string
): Promise<TestRow> => {
  let slug = ApiEndpoints.test + "/" + test.id;

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "PUT", body: test });

  return fetchData<TestRow>(slug, options);
};

export const createTest = async (
  test: CreateTestRow,
  patientUserId?: string
): Promise<TestRow> => {
  let slug = ApiEndpoints.test + "/";

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "POST", body: test });

  return fetchData<TestRow>(slug, options);
};

export const getTest = async (testId: string): Promise<TestRowWithResult> => {
  const slug = ApiEndpoints.test + `/${testId}`;

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<TestRowWithResult>(slug, options);
};
